import React, {useState, useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {notification} from 'antd'
import PropTypes from 'prop-types'

import Callback from './containers/Callback'
import OauthCallback from './containers/OauthCallback'
import Login from './containers/Login'

function App ({history}) {
  const intl = useIntl()

  const [error, setError] = useState(null)
  const onError = (status, e) => {
    setError({
      statusCode: status,
      message: (e && e.message) ? e.message : ''
    })
  }

  useEffect(() => {
    if (error && error.statusCode >= 500) {
      notification.warn({
        message: intl.formatMessage({id: 'error'}),
        description: intl.formatMessage({id: 'callback.error'}, error)
      })
    }
  }, [error, intl])

  return (
    <Switch>
      {!error && <Route exact path='/callback' render={(props) => <Callback {...props} onError={onError} />} />}
      {!error && <Route exact path='/oauth/callback' render={(props) => <OauthCallback {...props} onError={onError} />} />}
      <Route component={Login} exact path='/' />
      <Redirect to='/' />
    </Switch>
  )
}
App.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
}
export default App
